import React, { useState } from "react";
import useTitanApp from "../../../hooks/useTitanApp";
import { setShowPrescriptionPreviewModal } from "../../../dispatchers/patientDispatchers";
import {
  Modal,
  Box,
} from "@mui/material";
import { IoClose } from "react-icons/io5";

export default function PrescriptionPreviewModal() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const { showPrescriptionPreviewModal, prescriptionImageBase64 } =
    patientState || {};

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: darkMode ? "#222" : "#fff",
    boxShadow: 24,
    borderRadius: "16px",
  };

  const handleCloseModal = () => {
    setShowPrescriptionPreviewModal(false);
  }

  return (
    <Modal open={showPrescriptionPreviewModal}>
      <Box sx={style}>
        <div className="pc-actions-modal-wrapper prescription-preview">
          <div className="pc-actions-modal-header">
            <h3>Prescription preview</h3>
            <IoClose
              className="close-icon"
              onClick={handleCloseModal}
              color={darkMode ? "#f2f2f2" : "#222"}
            />
          </div>
          <div className="pc-actions-modal-content">
            <img
              src={prescriptionImageBase64}
              alt="Prescription Preview"
              className="preview-image"
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
